import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories, subcategories, getMoviesByCategory } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState('movie');
  const [activeSub, setActiveSub] = useState<string | null>(null);
  const navigate = useNavigate();

  const currentMovies = getMoviesByCategory(activeCategory);
  const currentSubs = subcategories[activeCategory] || [];
  const filteredMovies = activeSub
    ? currentMovies.filter((m) => m.subcategory === activeSub)
    : currentMovies;

  const handleViewAll = () => {
    navigate(`/category/${activeCategory}`);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-2">
              海量影视资源
            </h2>
            <p className="text-sm text-foreground-500">高清蓝光画质，分类详尽，找片更轻松</p>
          </div>
          <div className="flex items-center gap-1 bg-background-200/60 rounded-full p-1">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => {
                  setActiveCategory(cat.slug);
                  setActiveSub(null);
                }}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </div>
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {currentSubs.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 mb-6">
            <button
              onClick={() => setActiveSub(null)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeSub === null
                  ? 'bg-accent-500 text-foreground-950'
                  : 'bg-background-50 text-foreground-600 hover:text-foreground-950 border border-background-200/70'
              }`}
            >
              全部
            </button>
            {currentSubs.map((sub) => (
              <button
                key={sub}
                onClick={() => setActiveSub(sub)}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeSub === sub
                    ? 'bg-accent-500 text-foreground-950'
                    : 'bg-background-50 text-foreground-600 hover:text-foreground-950 border border-background-200/70'
                }`}
              >
                {sub}
              </button>
            ))}
          </div>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {filteredMovies.slice(0, 12).map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="text-center mt-8">
          <button
            onClick={handleViewAll}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-700 text-sm font-medium rounded-full border border-background-200/70 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            查看全部{ categories.find((c) => c.slug === activeCategory)?.name }
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}